/**
 *
 * GoogleVerify
 *
 */
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Button from 'ui/components/Button';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectIsVerify, makeSelectError } from './selectors';
import { verifyGoogle } from './actions';
import reducer from './reducer';
import saga from './saga';
import queryString from 'query-string';
import {
  VerifyContainer,
  VerifyContent,
  VerifyHeaderWrapper,
  VerifyDivider,
  VerifyLogo,
} from './styled';
import logo from 'assets/img/brand/logo-full.png';
import { NOTIFICATION } from 'common/constants';
import triggerNotification from 'utils/triggerNotification';

export const GoogleVerify = props => {
  useInjectReducer({ key: 'googleVerify', reducer });
  useInjectSaga({ key: 'googleVerify', saga });

  const { verifyGoogleStart, isVerify, error, history } = props;

  const verifyCode = queryString.parse(props.location.search).code;
  let state;

  try {
    state = JSON.parse(decodeURIComponent(queryString.parse(props.location.search).state));
  } catch (e) {
    triggerNotification({
      title: 'Something went wrong. Please try again',
      type: NOTIFICATION.TYPE.ERROR,
    });
  }
  useEffect(() => {
    if (verifyCode && state) {
      verifyGoogleStart({
        payload: { code: verifyCode, state: JSON.stringify(state) },
        metadata: { history },
      });
    }

    // eslint-disable-next-line
  }, [verifyCode]);

  return (
    <>
      <Helmet>
        <title>ZoomInfo Chat | Verify Google</title>
        <meta name="description" content="Verify your Google" />
      </Helmet>
      <VerifyContainer>
        <div className="d-flex justify-content-center p-5">
          <VerifyLogo src={logo} alt="zoominfo chat logo" />
        </div>
        <VerifyContent>
          {isVerify ? (
            <>
              <VerifyHeaderWrapper>Pending</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Verification Pending</p>
            </>
          ) : error ? (
            <>
              <VerifyHeaderWrapper>Failed</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Something went wrong while connecting Google with ZoomInfo Chat</p>
            </>
          ) : (
            <>
              <VerifyHeaderWrapper>Successful</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Successfully connected your Google with ZoomInfo Chat </p>
            </>
          )}
        </VerifyContent>
      </VerifyContainer>
    </>
  );
};
GoogleVerify.propTypes = {
  verifyGoogleStart: PropTypes.func.isRequired,
};
export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    isVerify: makeSelectIsVerify(),
    error: makeSelectError(),
  });
};
export const mapDispatchToProps = dispatch => {
  return {
    verifyGoogleStart: ({ payload, metadata }) =>
      dispatch(verifyGoogle.start({ payload, metadata })),
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(GoogleVerify);
